import React from 'react';
import AuctionComponent from '../components/auction/AuctionComponent';

export default function AuctionContainer(props) {
    return (
        <AuctionComponent/>
    );
}